import type { TargetAudience } from 'common/enums/target-audience.enum';
import BaseChangeset from 'common/changesets/base';

export type IntraFormDTO = {
  type: string;
  title: string;
  targetAudience: TargetAudience | undefined;
  name: string;
  email: string;
  phone: string;
  message: string;
};

export class IntraFormChangeset extends BaseChangeset<IntraFormDTO> {}
